export const CUTOFF = 13.75 * 2;